import { useEffect, useState } from 'react';
import {
    useLocation,
    useNavigate,
} from 'react-router-dom';
import styled from 'styled-components';
import { Card, Typography } from "@mui/material";

import { IconChevronLeft, IconTrash, IconDeviceFloppy,  } from '@tabler/icons-react';

import { useRolesHook } from '../../../Hooks/Maintenance/Accessibilities/rolesHooks';

import { Role, RoleAccesibility } from '../../../Models/Maintenance/Accessibilities/Roles';

import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';
import RouteHelper from '../../../Utilities/Helpers/RouteHelper';
import AccessibilityHelper from '../../../Utilities/Helpers/AccessibilityHelper';
import GlobalFunctionHelper from '../../../Utilities/Helpers/GlobalFunctionHelper';

import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';
import { RolesField, RoleAccesibilityField } from '../../../Utilities/Enums/ParametersEnum';
import { RouteEnum } from '../../../Utilities/Enums/RouteEnums';
import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';
import { AdminModules } from '../../../Utilities/Enums/AdminModulesEnum';

import CustomDetailsCard from '../../../CustomViews/Pages/CustomDetailsCard/CustomDetailsCard';
import CustomButton from '../../../CustomViews/Elements/CustomButton';
import CustomDeleteConfirmation from '../../../CustomViews/Elements/CustomDeleteConfirmation/CustomDeleteConfirmation';
import CustomCheckbox from '../../../CustomViews/Elements/CustomCheckbox';

const DetailsContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    display: grid;
    grid-template-columns: auto;
    gap: 30px;
    box-shadow: none !important;
    padding: 10px 0px;
    overflow: visible !important;
`;

const AdminModulesContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    display: grid;
    grid-template-columns: auto;
    gap: 40px;
    box-shadow: none !important;
    width: 50%
`;

const AdminModuleItem = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 5px;
    box-shadow: none !important;

    .adminModuleTitle {
        grid-column: span 4;
        font-size: 16px;
        font-weight: 600;
        text-decoration: underline !important;
    }
`;

export default function AccessibilityDetails() {
    let navigate = useNavigate();
    let location = useLocation();
    let queryParams = new URLSearchParams(location.search);
    let roleid = queryParams.get('id') ?? "0";

    //Use States
    let [previewData, setpreviewData] = useState<Role>(new Role());
    let [roleAccessibilities, setroleAccessibilities] = useState<RoleAccesibility[]>([]);
    let [openDelete, setopenDelete] = useState(false);
    const [queryStr, setQueryStr] = useState({
        pageSize: QueryBuilderHelper.DefaultPageSizeValue(),
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

    const q_queryKey = [CachingEnum.ACCESSIBILITIES, queryStr]
    const { DropdownData, dropdownFetchStatus, getRoleById, deleteRoleById, getRolesAccessibilityByRoleId, upsertRoleAccessibilities } = useRolesHook(q_queryKey, queryStr, false);

    //Event Handlers
    const getRoleData = async () => {
        if(roleid != '0') {
            
            let getDetails = await getRoleById(roleid);
            let _previewData = {...previewData};

            if(getDetails?.data) {
                _previewData = {...previewData, ...getDetails.data};
            }

            setpreviewData(_previewData);
        }
    }

    const getAccessibilityData = async () => {
        let _roleAccessibilities = [...roleAccessibilities];
        let getRoleAccessibilities = await getRolesAccessibilityByRoleId(roleid);

        if(DropdownData?.[CachingEnum.ADMIN_MODULES]) {
            setroleAccessibilities(await AccessibilityHelper.mapRoleAccessibilities(DropdownData?.[CachingEnum.ADMIN_MODULES], getRoleAccessibilities?.data ?? []));
        }
    }

    const handleSubmit = async () => {
        let upsertResponse = await upsertRoleAccessibilities(roleid, JSON.stringify(roleAccessibilities));
        let _success: boolean = upsertResponse?.isSuccess ?? false;

        if(_success) {
            getAccessibilityData();
        }
    }

    useEffect(() => {
        getRoleData();
    }, [roleid]);

    useEffect(() => {
        if(!dropdownFetchStatus) {
            getAccessibilityData();
        }
    }, [dropdownFetchStatus]);

    

    //Rendering Functions
    const renderActionButtons = () => {
        return <>
            <CustomButton
                btnType={ButtonType.CANCEL}
                title='Back'
                startIcon={<IconChevronLeft />}
                // isRoundedCorner={true}
                onClick={(e: any) => {
                    GlobalFunctionHelper.goBack(navigate, location, RouteEnum.PRICE_SETTING);
                }} />
            {AccessibilityHelper.hasAccess(AdminModules.ACCESSIBILITIES_DELETE) && <CustomButton
                btnType={ButtonType.DELETE}
                title='Delete'
                startIcon={<IconTrash />}
                // isRoundedCorner={true}
                onClick={(e: any) => {
                    setopenDelete(true);
                }} />}
            {AccessibilityHelper.hasAccess(AdminModules.ACCESSIBILITIES_EDIT) && <CustomButton
                btnType={ButtonType.SUCCESS}
                title='Save'
                startIcon={<IconDeviceFloppy />}
                // isRoundedCorner={true}
                onClick={(e: any) => {
                    handleSubmit();
                }} />}
        </>
    }

    const renderAdminModules = () => {
        return <AdminModulesContainer>
            {DropdownData?.[CachingEnum.ADMIN_MODULES]?.map((moduleItem: any) => (
                <AdminModuleItem>
                    <Typography color="primaryText" className="adminModuleTitle">{moduleItem?.name ?? "--"}</Typography>
                    {moduleItem?.subItems?.map((subItem: any) => {
                        let itemIndex = roleAccessibilities?.findIndex((raItem: any) => raItem?.[RoleAccesibilityField.ACCESSIBILITY_ID] == subItem?.id);
                        
                        return <CustomCheckbox
                            name={'roleAccessibility' + subItem?.id}
                            title={subItem?.name ?? "--"}
                            checkboxType={ButtonType.PRIMARY}
                            fieldValue={roleAccessibilities[itemIndex]?.[RoleAccesibilityField.IS_PERMITTED]}
                            disabled={!AccessibilityHelper.hasAccess(AdminModules.ACCESSIBILITIES_EDIT)}
                            handleOnChange={(a: any) => {
                                let _roleAccessibilities: RoleAccesibility[] = [];

                                roleAccessibilities.forEach((item: any, index: number) => {
                                    _roleAccessibilities.push((index == itemIndex?
                                        {...item, [RoleAccesibilityField.IS_PERMITTED]: a} : {...item}
                                    ));
                                });

                                setroleAccessibilities(_roleAccessibilities);
                            }}
                            errorMessages={{}} />
                    })}
                </AdminModuleItem>
            ))}
        </AdminModulesContainer>

        
    }

    return <DetailsContainer>
        <CustomDetailsCard
        title={'Role: ' + previewData?.[RolesField.NAME]}
        actionButtons={renderActionButtons()} >
            {renderAdminModules()}
        </CustomDetailsCard>

        {openDelete && <CustomDeleteConfirmation
            openDialog={openDelete}
            handleClose={() => { setopenDelete(false); }}
            ItemToDelete={previewData?.[RolesField.NAME] ?? null} // Optional to display name of the item to be deleted
            showRemarksField={true}
            deleteItem={async (remarks: any) => {
                if(previewData?.[RolesField.PUBLIC_ID]) {
                    let deleteReponse: any = await deleteRoleById(previewData?.[RolesField.PUBLIC_ID], remarks);

                    if(deleteReponse?.isSuccess) {
                        setopenDelete(false);
                        navigate(RouteEnum.ACCESSIBILITIES, { replace: true });
                    }
                }
            }} />
        }
    </DetailsContainer>
}
